<template>
    <div class="header-part">
        <img src="@/assets/img/icon-kpmglogo.svg" width="100%" class="logo-icon-cls" />
        <span v-if="$i18n.locale==='en'" @click="toogleLanguage" style="cursor: pointer">切换中文<i class="el-icon-caret-right" /> </span>
        <span v-else-if="$i18n.locale==='zh'" @click="toogleLanguage" style="cursor: pointer">English<i class="el-icon-caret-right" /> </span>
    </div>
</template>

<script>
export default {
    name: "LoginTop",
    inject: ['reload'],
    methods: {
        toogleLanguage() {
            let locale = this.$i18n.locale
            locale === 'zh' ? (this.$i18n.locale = 'en') : (this.$i18n.locale = 'zh')
            localStorage.setItem('lang', this.$i18n.locale)
        },
    }
}
</script>

<style scoped>
.header-part{
    width: 100%;
    height: 123px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 40px 0 30px;
    font-size: 24px;
    color: #fff;
}
.logo-icon-cls{
    width: 135px;
}
</style>